module.exports = __webpack_public_path__ + "static/media/background-onboarding-space.d6c303c8.png";